import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDiscountPayload } from "../../types/order";
import { handleRequest } from "../../helpers/handleAsync";
import discountService from "../../services/discountService";

const calculateDiscount = createAsyncThunk(
    'discount/calculate',
    async (discountInfo: IDiscountPayload) => {
        const [res, err] = await handleRequest(discountService.calculateDiscount(discountInfo));
        if (!res || err) {
            throw new Error('Unknow error');
        }
        return res;
    }
)

export const discountPrvSliceActions = { calculateDiscount };